export const RewardValueType = Object.freeze({
  FIXED_VALUE: 'FIXED_VALUE',
  VARIABLE_VALUE: 'VARIABLE_VALUE',
  SUMMARY_VALUE: 'SUMMARY_VALUE'
})
